import {
  Faq as HygraphFaq,
  FaqGroup as HygraphFaqGroup,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { Faq, FaqGroupDefaults, FaqGroupProps } from '@/components/faq-group';

export default function faqGroupTransformer(
  hygraphFaqGroup: HygraphMaybe<HygraphFaqGroup> | undefined
): FaqGroupProps | undefined {
  if (!hygraphFaqGroup) return undefined;

  return {
    index: hygraphFaqGroup.index || 0,
    title: hygraphFaqGroup.title || 'Frequently asked questions',
    subtitle: '',
    faqs: faqsTransformer(hygraphFaqGroup.faqs) || [],
    design: hygraphFaqGroup.design || FaqGroupDefaults.design,
  };
}

export function faqsTransformer(hygraphFaqs: HygraphFaq[]): Faq[] {
  return hygraphFaqs.map(faqTransformer);
}

export function faqTransformer(hygraphFaq: HygraphFaq, index: number): Faq {
  return {
    id: hygraphFaq.id || String(index),
    title: hygraphFaq.title || '',
    content: hygraphFaq.content || '',
    defaultOpen: hygraphFaq.defaultOpen ?? true,
  };
}
